import React, { useState, useContext, useEffect } from "react"
import { motion } from "framer-motion"
import Burger from "../images/burger.svg"
import { Box, Image } from "@theme-ui/components"
import Logo from "../images/logo-rgb.svg"
import LogoWhiteBlack from "../images/diginnova-white-barra-nera.svg"
import LogoBlack from "../images/logo-mobile-black.svg"
import X from "../images/close.svg"
import { getHomePath } from "../utils/path"
import { InboundLink } from "./link"
import { MagicLink } from "../utils/magicLink"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import { MenuContext } from "../context/menuContext"
import { useBreakpointIndex } from "@theme-ui/match-media"
import { FooterContext } from "../context/footerContext"
const MobileNav = ({ primaryNav, background }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)
  const locale = useContext(LanguageSwitcherContext).activeLocale
  const menu = useContext(MenuContext)
  const mediaIndex = useBreakpointIndex()
  const footer = useContext(FooterContext)

  console.log(primaryNav)
  footer &&
    footer.map(footerItem => {
      footerItem.treeChildren.sort((a, b) => a.position - b.position)
      footerItem.treeChildren.map(footerItem => {
        if (footerItem.treeChildren.length > 0) {
          footerItem.treeChildren.sort((a, b) => a.position - b.position)
        }
      })
    })

  menu &&
    menu.map(menuItem => {
      menuItem.treeChildren.sort((a, b) => a.position - b.position)
      menuItem.treeChildren.map(menuItem => {
        if (menuItem.treeChildren.length > 0) {
          menuItem.treeChildren.sort((a, b) => a.position - b.position)
        }
      })
    })

  const mobileMenuVariant = {
    opened: {
      y: "0%",
      zIndex: 100,
      transition: {
        // delay: 0.15,
        duration: 0.5,
        ease: [0.74, 0, 0.19, 1.02],
      },
    },
    closed: {
      y: "-200%",
      transition: {
        // delay: 0.35,
        duration: 0.6,
        ease: [0.74, 0, 0.19, 1.02],
      },
    },
  }

  useEffect(() => {
    if (mobileNavOpen) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "initial"
    }
  }, [mobileNavOpen])

  console.log("mediaIndex", mediaIndex, useBreakpointIndex())

  return mediaIndex <= 2 ? (
    <Box
      sx={{
        position: "relative",
        zIndex: 100000000,
        backgroundColor:
          primaryNav === true
            ? "primary"
            : background === "#eeeeee"
            ? "lightGrey"
            : "light",
      }}
    >
      <motion.nav
        initial="closed"
        animate={mobileNavOpen ? "opened" : "closed"}
        style={{
          a: {
            textTransform: "uppercase",
          },
          zIndex: 100000,
          display: "flex",
          alignContent: "center",
          alignItems: "center",
          justifyContent: "space-between",
          paddingBottom: "10px",
          paddingTop: "15px",
          paddingLeft: "20px",
          paddingRight: "20px",
          position: "relative",
        }}
      >
        <Box sx={{ a: { display: "block" } }}>
          <InboundLink to={getHomePath(locale)} className="logo-link">
            <Image
              sx={{ height: "40px" }}
              src={primaryNav ? LogoWhiteBlack : Logo}
              alt="Logo"
            />
          </InboundLink>
        </Box>
        <Box sx={{}} onClick={() => setMobileNavOpen(!mobileNavOpen)}>
          <Image sx={{ height: "30px", width: "30px" }} src={Burger} />
        </Box>
        <motion.div
          variants={mobileMenuVariant}
          style={{
            zIndex: 1000,
            position: "fixed",
            top: "0",
            left: "0",
            height: "100vh",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            alignItems: "center",
            backgroundColor: "#9C73FF",
            overflowY: "auto",
          }}
        >
          <Box
            sx={{
              paddingX: 2,
              paddingY: 3,
              width: "100%",
              display: "flex",
              alignItems: "center",
              alignContent: "center",
              backgroundColor: "primary",
              justifyContent: "space-between",
              a: {
                textTransform: "uppercase",
              },
            }}
          >
            <InboundLink to={getHomePath(locale)} className="logo-link">
              <Image sx={{ height: "40px" }} src={LogoWhiteBlack} alt="Logo" />
            </InboundLink>
            <Box sx={{}} onClick={() => setMobileNavOpen(false)}>
              <Image sx={{ height: "30px", width: "30px" }} src={X} />
            </Box>
          </Box>
          {menu && menu.length > 0 && (
            <motion.ul
              style={{
                marginTop: [7],
                listStyle: "none",
                paddingLeft: "16px",
                width: "100%",
                a: {
                  backgroundColor: "dark",
                  textTransform: "uppercase",
                },
              }}
            >
              {menu.map(navItem => (
                <motion.li
                  whileTap={{ scale: 0.95 }}
                  key={"mobile" + navItem.id}
                  style={{
                    overflowY: "hidden",
                    userSelect: "none",
                  }}
                >
                  <motion.div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      textTransform: "capitalize",
                      padding: "15px 0",
                    }}
                  >
                    {navItem.link ? (
                      <MagicLink
                        variant="links.nav"
                        item={navItem.link}
                        locale={locale}
                        sx={{
                          color: "light",
                          backgroundColor: "dark",
                          borderRadius: "80px",
                          textTransform: "uppercase",
                          textDecoration: "none",
                          py: "10px",
                          px: "15px",
                          fontSize: ["18px"],
                          "&.active": {
                            color: "light",
                          },
                        }}
                      />
                    ) : (
                      <Box sx={{ cursor: "default" }}>{navItem.anchor}</Box>
                    )}
                  </motion.div>
                </motion.li>
              ))}
            </motion.ul>
          )}
          {/*       {menu && menu.length > 0 && (
            <motion.ul
              variants={ulVariant}
              style={{
                borderTop: "1px solid",
                borderBottom: "1px solid",
                borderColor: "dark",
                padding: "45px 0",
                columns: 2,
                listStyle: "none",
                paddingLeft: 0,
                width: "100%",
                a: {
                  textTransform: "uppercase",
                },
              }}
            >
              {footer.map(
                navItem =>
                  navItem.treeChildren &&
                  navItem.treeChildren.length > 0 &&
                  navItem.treeChildren.map(child => (
                    <motion.li
                      whileTap={{ scale: 0.95 }}
                      key={navItem.id}
                      style={{
                        overflowY: "hidden",
                        userSelect: "none",
                      }}
                    >
                      <motion.div
                        variants={liVariant}
                        style={{
                          textTransform: "capitalize",
                          padding: "15px 0",
                        }}
                      >
                        {child.link ? (
                          <MagicLink
                            variant="links.nav"
                            item={child.link}
                            locale={locale}
                            sx={{
                              textTransform: "uppercase",
                              fontSize: [2],
                              "&.active": {
                                color: "light",
                              },
                            }}
                          />
                        ) : (
                          <Box sx={{ cursor: "default" }}>{child.anchor}</Box>
                        )}
                      </motion.div>
                    </motion.li>
                  ))
              )}
            </motion.ul>
          )} */}
        </motion.div>
      </motion.nav>
    </Box>
  ) : null
}

export default MobileNav
